<script>
import ChatBotPreview from "../../components/ChatBotPreview/ChatBotPreview.vue";
import ColorPicker from "../../components/ColorPicker/ColorPicker.vue";
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import FormSelect from "../../components/shared/FormSelect.vue";
import ImageUploadInput from "../../components/shared/ImageUploadInput.vue";
import InputWebsiteVue from "../../components/shared/InputWebsite.vue";
import CustomSelect from "../../components/shared/UI/CustomSelect.vue";
import Toggle from "../../components/shared/UI/Toggle.vue";
import store from "../../vuex/store";
export default {
  components: {
    InputWebsiteVue,
    Toggle,
    CustomSelect,
    ButtonWithLoadWebsite,
    ImageUploadInput,
    ChatBotPreview,
    ColorPicker,
    FormSelect,
  },
  watch: {
    data: {
      handler(oldData, newData) {
        if (JSON.stringify(oldData) !== JSON.stringify(newData)) {
          this.botData = this.data;
        }
      },
      deep: true,
    },
    botData: {
      deep: true,
      handler: function () {
        if (this.formType === "create") {
          store.dispatch("updateCreateBotData", this.botData);
          // localStorage.setItem("botSettings", JSON.stringify(this.botData));c
        } else if (this.formType === "update") {
          // console.log(this.botData)
          store.dispatch("updateDataChange", this.botData);
        } else {
          return;
        }
      },
    },
  },
  computed: {
    botSettings() {
      const botIconPreview = this.botIconPreview;
      const userIconPreview = this.userIconPreview;
      const agentIconPreview = this.agentIconPreview;

      return {
        ...this.botData,
        botIconPreview,
        userIconPreview,
        agentIconPreview,
      };
    },
  },
  methods: {
    getPrimaryColor() {
      return this.botData?.primaryColor;
    },
    updateBotDataField({ key, value }) {
      this.botData[key] = value;
    },

    updateBotDataIcons({ key, value, preview }) {
      this.updateBotDataField({ key, value });

      if (key === "botIcon") {
        this.botIconPreview = preview;
      }

      if (key === "userIcon") {
        this.userIconPreview = preview;
      }

      if (key === "agentIcon") {
        this.agentIconPreview = preview;
      }
    },
    setPrimaryColor(color) {
      this.botData.primaryColor = color;
    },
    setTextColor(color) {
      this.botData.textColor = color;
    },
    previewToggle() {
      this.previewShow = !this.previewShow;
    },
  },
  props: ["data", "formType"],
  data() {
    return {
      placeholder: "My Company Chatbot",
      placeholder1: "Hello! How can I help you?",
      placeholder2: "#4764d5",
      placeholder3: "#828F9A",
      placeholder4: 16,
      placeholder5: 550,
      placeholder6: "Learn More",
      placeholder7: "Ask me anything",
      placeholder8: 16,
      placeholder9: 16,
      selectedOption: "value1",
      iconSize: {
        48: "Small (48x48px)",
        60: "Medium (60x60px)",
        72: "Large (72x72px)",
      },
      iconPosition: {
        BR: "Bottom - right",
        BL: "Bottom - left",
      },
      botData: null,
      botIconPreview: "",
      userIconPreview: "",
      agentIconPreview: "",
      previewShow: false,
    };
  },
  mounted() {
    // if (localStorage.botSettings && this.formType === 'create') {
    //   this.botData = JSON.parse(localStorage.getItem("botSettings"));
    // } else {
    //   this.botData = this.$props.data;
    // }
    this.botData = this.$props.data;
  },
};
</script>

<template>
  <div v-if="botData" class="">
    <div v-if="$route.path === '/user/bot_settings'" class="create_from">
      <sidebar-link class="create_hover" to="/user/create_bot">
        <img src="@/assets/img/icn_back.svg" alt="" />
      </sidebar-link>
      <div class="create_from_bc">Create new Chatbot</div>
      <div class="create_from_step">Step 2/2</div>

      <img src="@/assets/img/arrow_filling2.svg" alt="" />
    </div>

    <!-- {{ botData }} -->

    <div class="chat_bot_flex_section_box">
      <div class="chat_bot_flex_section">
        <div class="chat_bot">
          <div class="chat_bot_head">Content</div>
          <div class="chabot_flex">
            <div class="chat_bot_name">Chatbot name:</div>
            <div>
              <InputWebsiteVue
                type="text"
                minlength="3"
                maxlength="20"
                :placeholder="placeholder"
                v-model="botData.name"
                :className="{ empty_field: !botData.name }"
              />
              <div class="chat_bot_how">No more than 20 characters</div>
            </div>
          </div>
          <div class="chabot_flex">
            <div class="chat_bot_name">Welcome message:</div>
            <div>
              <InputWebsiteVue
                :placeholder="placeholder1"
                v-model="botData.welcomeMessage"
                :className="{ empty_field: !botData.welcomeMessage }"
              />
              <div class="chat_bot_how">
                The first message users will see in the Chatbot
              </div>
            </div>
          </div>
          <div class="chabot_flex">
            <div class="chat_bot_name">Input placeholder text:</div>
            <div>
              <InputWebsiteVue
                :placeholder="placeholder7"
                v-model="botData.placeholder"
              />
              <div class="chat_bot_how">
                The first message users will see in the Chatbot
              </div>
            </div>
          </div>
        </div>
        <div class="chat_bot_inter">
          <div class="chat_bot_head">
            Chat interface

            <div class="chat_bot_how">
              This will be applied when embedded on the website
            </div>
          </div>

          <div class="chabot_flex">
            <div class="chat_bot_name">Primary color:</div>
            <ColorPicker
              :setColor="setPrimaryColor"
              :default-color="botData.primaryColor"
            />
            <!-- <label :style="{background: botData.primaryColor, width: '233px', borderRadius: '6px'}">
              <InputWebsiteVue
                type="color"
                v-model="botData.primaryColor"
                :inputStyle="{
                  width: 0,
                  height: 0,
                  padding: 0,
                  border: 'none',
                }"
              />
            </label> -->
          </div>
          <div class="chabot_flex">
            <div class="chat_bot_name">Text color:</div>
            <ColorPicker
              :setColor="setTextColor"
              :default-color="botData.textColor"
            />
            <!-- <label :style="{background: botData.textColor, width: '233px', borderRadius: '6px'}">
              <InputWebsiteVue
                type="color"
                v-model="botData.textColor"
                :inputStyle="{
                  width: 0,
                  height: 0,
                  padding: 0,
                  border: 'none',
                }"
              />
            </label> -->
          </div>
          <div class="chabot_flex">
            <div class="chatbot_style short">
              <div class="chatbot_style_">
                <div class="chat_bot_name">Font size, px:</div>
                <div>
                  <InputWebsiteVue
                    type="number"
                    class="width"
                    :placeholder="placeholder4"
                    onblur="if(this.value<12)this.value=12; if(this.value>30)this.value=30"
                    :step="1"
                    :min="12"
                    :max="30"
                    popup="12px - 30px"
                    v-model="botData.fontSize"
                  />
                </div>
              </div>
              <div class="chatbot_style_">
                <div class="chat_bot_name">Chat height, px:</div>
                <div>
                  <InputWebsiteVue
                    type="number"
                    class="width"
                    onblur="if(this.value<550)this.value=550; if(this.value>700)this.value=700"
                    :placeholder="placeholder5"
                    :step="10"
                    :min="550"
                    :max="700"
                    popup="550px - 700px"
                    v-model="botData.chatHight"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="chabot_flex">
            <div class="chat_bot_name">Learn more (Localization):</div>
            <div>
              <InputWebsiteVue
                :placeholder="placeholder6"
                v-model="botData.localization"
              />
            </div>
          </div> -->
          <!-- <div>
            <div class="chatbot_toggle">
              <div>Hide learn more</div>
              <Toggle
                :id="1"
                :fieldKey="'hideLearnMore'"
                :fieldValue="botData.hideLearnMore"
                @update:fieldValue="updateBotDataField"
              />
            </div>
            <div class="chat_bot_how top">
              Hide the sources from there the response got generated
            </div>
          </div> -->
          <!-- <div>
            <div class="chatbot_toggle">
              <div>Hide ToolTip</div>
              <Toggle
                :id="2"
                :fieldKey="'hideToolTip'"
                :fieldValue="botData.hideToolTip"
                @update:fieldValue="updateBotDataField"
              />
            </div>
            <div class="chat_bot_how top">
              Turn this on if you don’t want to show the tooltip on chat icon
            </div>
          </div>
          <div>
            <div class="chatbot_toggle">
              <div>Hide Feedback button</div>
              <Toggle
                :id="3"
                :fieldKey="'hideFeedbackButton'"
                :fieldValue="botData.hideFeedbackButton"
                @update:fieldValue="updateBotDataField"
              />
            </div>
            <div class="chat_bot_how top">
              Turn this on if you don’t want to show thumbs up and thumbs down
            </div>
          </div> -->
          <!-- <div>
            <div class="chatbot_toggle">
              <div>RTL mode</div>
              <Toggle
                :id="5"
                :fieldKey="'rtlMode'"
                :fieldValue="botData.rtlMode"
                @update:fieldValue="updateBotDataField"
              />
            </div>
            <div class="chat_bot_how top">
              Turn this on if you don’t want your chat bot to be in rtl mode
            </div>
          </div> -->
        </div>
        <div class="chat_bot_inter">
          <div class="chat_bot_head">
            Chat icon
            <div class="chat_bot_how">
              Customise the position and size of the chat button
            </div>
          </div>
          <div class="chabot_flex">
            <div class="chatbot_style">
              <div class="chatbot_style_">
                <div class="chat_bot_name">Distance from bottom (in px):</div>

                <InputWebsiteVue
                  type="number"
                  onblur="if(this.value<0)this.value=0; if(this.value>300)this.value=300"
                  class="width_icon"
                  :step="1"
                  :min="0"
                  :max="300"
                  popup="0px - 300px"
                  :placeholder="placeholder8"
                  v-model="botData.iconFromBottomDistance"
                />
              </div>
              <div class="chatbot_style_">
                <div class="chat_bot_name">Horizontal distance (in px):</div>
                <InputWebsiteVue
                  type="number"
                  onblur="if(this.value<0)this.value=0; if(this.value>300)this.value=300"
                  class="width_icon"
                  :step="1"
                  :min="0"
                  :max="300"
                  popup="0px - 300px"
                  :placeholder="placeholder9"
                  v-model="botData.iconHorizontalDistance"
                />
              </div>
            </div>
          </div>
          <div class="chabot_flex">
            <div class="chatbot_style">
              <div class="chatbot_style_">
                <div class="chat_bot_name">Chat icon size:</div>
                <FormSelect
                  type="objArray"
                  :items="Object.entries(iconSize)"
                  name="iconSize"
                  :user-select="iconSize[botData.iconSize]"
                  :handleSelect="updateBotDataField"
                />
              </div>
              <div class="chatbot_style_">
                <div class="chat_bot_name">Position:</div>
                <FormSelect
                  type="objArray"
                  :items="Object.entries(iconPosition)"
                  name="iconPosition"
                  :user-select="iconPosition[botData.iconPosition]"
                  :handleSelect="updateBotDataField"
                />
              </div>
            </div>
          </div>
          <div class="chabot_flex">
            <div class="chat_bot_name">Select Bot icon:</div>
            <ImageUploadInput
              :className="{ empty_field: !botData.botIcon }"
              label="Choose file"
              :fieldKey="'botIcon'"
              :exist-img-url="botData.botIcon"
              @change="updateBotDataIcons"
            />
          </div>

          <div class="chabot_flex">
            <div class="chat_bot_name">Select User icon:</div>
            <ImageUploadInput
              label="Choose file"
              :fieldKey="'userIcon'"
              :exist-img-url="botData.userIcon"
              @change="updateBotDataIcons"
            />
          </div>

          <div class="chabot_flex">
            <div class="chat_bot_name">Select Agent icon:</div>
            <ImageUploadInput
              label="Choose file"
              :fieldKey="'agentIcon'"
              :exist-img-url="botData.agentIcon"
              @change="updateBotDataIcons"
            />
          </div>
        </div>
      </div>
      <div
        class="chat_bot_flex_section preview"
        :class="{ preview_show: previewShow }"
      >
        <ChatBotPreview
          :previewShow="previewShow"
          :previewToggle="previewToggle"
          :form-type="formType"
          :botSettings="botSettings"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.bot_settings_cont {
  padding: 48px 48px 70px 48px;
  overflow: auto;
  height: calc(100% - 201px);
}

.create_from {
  display: flex;
  gap: 16px;
}

.create_from_bc {
  font-size: 24px;
  line-height: 30px;
  font-weight: bold;
}

.create_from_step {
  font-size: 16px;
  line-height: 30px;
  font-weight: bold;
  color: #bdbdbd;
}

.chat_bot_head {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.top {
  padding-top: 10px !important;
}
.chat_bot {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.width {

}

.width_icon {
  @media (min-width: 580px) {
    width: 224px;
  }
}
.chat_bot_flex_section_box {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 51px;
}
.chat_bot_flex_section {
  transition: all 150ms linear;

  &.preview {
    @media (max-width: 1119px) {
      position: absolute;
      top: 70px;
      right: -430px;

      @media (max-width: 560px) {
        right: -80vw;
      }

      &.preview_show {
        right: 38px;
      }
    }
  }
}
.chat_bot_name {
  color: #000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.chat_bot_name_ {
  color: #f00;
}
.chat_bot_photo {
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 560px) {
    flex-direction: row;
    align-items: center;
  }
}
.chatbot_style {
  display: grid;
  gap: 16px;

  &.short {
    grid-template-columns: 1fr 1fr;
    max-width: 312px;
  }

  @media (min-width: 560px) {
    grid-template-columns: 1fr 1fr;
  }
}
.chabot_flex {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.chat_bot_how {
  color: #bdbdbd;
  padding-top: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.chat_bot_inter {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 32px;
}
.chatbot_photo_text {
  color: #4f4f4f;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.chatbot_toggle {
  display: flex;
  align-items: center;
  gap: 16px;
}
.chatbot_style_ {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.grey-text {
  color: #4f4f4f;
}
</style>
